import { Select } from 'antd';
import { ESQUnit } from '@/types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { sunkenAntSelectClasses } from '@/utils/sunkenAntSelectStyle';

export interface MeasureUnitSelectProps {
  value: ESQUnit;
  onChange: (value: ESQUnit) => void;
  className?: string;
}

// Use Ant Select rather than the in-house Radix-based primitive: Radix
// Select's internal `useComposedRefs` builds an identity-unstable callback
// ref each render, which under React's strict callback-ref semantics
// dispatches state on every detach/attach and loops on mount. Ant Select is
// already used elsewhere in this Dashboard.
// Verify against @radix-ui/react-select ≥ 2.1 / React ≥ 19.1 before reverting.
//
// Trigger styled to match sibling Input components in DetailsPanel
// (bg-surface-sunken, rounded, py-4) for visual parity with the prior
// Radix-based trigger.
export function MeasureUnitSelect({ value, onChange, className }: MeasureUnitSelectProps) {
  const { t } = useTranslation();

  const options = [
    { value: ESQUnit.METRIC, label: `${t('meters')} (m)` },
    { value: ESQUnit.FEET, label: `${t('feet')} (ft)` },
  ];

  return (
    <Select
      variant="borderless"
      value={value ?? ESQUnit.FEET}
      onChange={onChange}
      options={options}
      style={{ width: '100%' }}
      className={clsx(sunkenAntSelectClasses, '[&_.ant-select-selector]:!py-4', className)}
    />
  );
}
